// Coffee-dark editorial footer with the big "Nala.vet" wordmark and the
// 5-column link grid spec'd in tmp/handoff/README.md. Most links are
// placeholder strings until the corresponding pages exist — see the
// README's "open questions" section.

import { Link } from 'react-router-dom'
import { nala } from './palette'

type Column = {
  heading: string
  links: { label: string; to?: string; href?: string }[]
}

const COLUMNS: Column[] = [
  {
    heading: 'About',
    links: [
      { label: 'Our story' },
      { label: 'Careers' },
    ],
  },
  {
    heading: 'Locations',
    links: [
      { label: 'Miami-Dade',     to: '/locations' },
    ],
  },
  {
    heading: 'Social',
    links: [
      { label: 'Instagram' },
      { label: 'Facebook' },
      { label: 'TikTok' },
    ],
  },
  {
    heading: 'Legal',
    links: [
      { label: 'Terms & Conditions', to: '/terms' },
      { label: 'Privacy Policy',     to: '/policy' },
      { label: 'Data & Deletion',    to: '/data-policy' },
    ],
  },
  {
    heading: 'Contact',
    links: [
      { label: 'hello@nala.vet',   href: 'mailto:hello@nala.vet' },
      { label: '(213) 833-8007',   href: 'tel:+12138338007' },
    ],
  },
]

export default function EditorialFooter() {
  return (
    <footer
      style={{
        background: nala.footer,
        color: nala.footerInk,
      }}
    >
      <div className="max-w-[1280px] mx-auto px-6 sm:px-10 lg:px-14 pt-16 pb-8">
        {/* Big wordmark + tagline */}
        <div
          className="pb-10"
          style={{ borderBottom: `1px solid rgba(232,220,196,0.12)` }}
        >
          <div
            className="text-[64px] sm:text-[80px] lg:text-[96px] leading-none"
            style={{
              fontFamily: nala.display,
              letterSpacing: '-0.03em',
              fontWeight: 400,
              color: '#f5e8cc',
            }}
          >
            Nala
            <span style={{ color: nala.clay, fontStyle: 'italic' }}>.vet</span>
          </div>
          <div
            className="italic mt-3 text-lg sm:text-xl max-w-md"
            style={{
              fontFamily: nala.display,
              color: '#c9b894',
              lineHeight: 1.35,
            }}
          >
            built for pets, inspired by pet parents.
          </div>
        </div>

        {/* Link columns */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 py-10">
          {COLUMNS.map((col) => (
            <div key={col.heading}>
              <div
                className="text-[11px] uppercase mb-4"
                style={{
                  letterSpacing: '0.18em',
                  color: nala.footerMute,
                }}
              >
                {col.heading}
              </div>
              {col.links.map((link) => {
                const className = 'block py-1 text-[15px]'
                const style = {
                  fontFamily: nala.display,
                  color: nala.footerInk,
                  textDecoration: 'none',
                }
                if (link.to) {
                  return (
                    <Link key={link.label} to={link.to} className={className} style={style}>
                      {link.label}
                    </Link>
                  )
                }
                if (link.href) {
                  return (
                    <a key={link.label} href={link.href} className={className} style={style}>
                      {link.label}
                    </a>
                  )
                }
                return (
                  <div key={link.label} className={className} style={style}>
                    {link.label}
                  </div>
                )
              })}
            </div>
          ))}
        </div>

        {/* Bottom row */}
        <div
          className="pt-6 flex flex-wrap items-center justify-between gap-4 text-xs"
          style={{
            color: nala.footerMute,
            borderTop: `1px solid rgba(232,220,196,0.12)`,
          }}
        >
          <span>© {new Date().getFullYear()} Nala Veterinary, Inc. · Miami, FL</span>
          <span className="space-x-3">
            <a href="/llms.txt" className="hover:opacity-80" style={{ color: nala.footerMute }}>
              llms.txt
            </a>
            <a href="/sitemap.xml" className="hover:opacity-80" style={{ color: nala.footerMute }}>
              Sitemap
            </a>
            <a href="/robots.txt" className="hover:opacity-80" style={{ color: nala.footerMute }}>
              robots.txt
            </a>
          </span>
        </div>
      </div>
    </footer>
  )
}
